/** Where the agent's summary divider goes in a list of messages, from each one's `seq`: the
    index of the last message the summary covers (`seq` up to `uptoSeq`), while one after it
    is in the list too; -1 when there is none. A message not saved yet (`seq` below 0) is never
    covered. The platform chat, the client app and the extension draw it by this one rule. */
export function summaryEnd(seqs: number[], uptoSeq: number | null | undefined): number {
  if (uptoSeq === null || uptoSeq === undefined) return -1;
  const end = seqs.findLastIndex((seq) => seq >= 0 && seq <= uptoSeq);
  return end < seqs.length - 1 ? end : -1;
}
